export default __webpack_public_path__ + "static/media/Group 10753.e02008c3.svg";